import {
  EWayBillReviewDataType,
  InitialStateInvoicingAdvanceType,
  PinCodeDistanceCountDataType,
} from "@/redux/invoicingAdvance/invoicingAdvance-types";

export const initialState: InitialStateInvoicingAdvanceType = {
  fetching: false,
  commentsFetching: false,
  downloadReportFetching: false,
  columnListFetching: false,
  OCRFetching: false,
  submittingInvoiceForm: false,
  bulkUploadLoading: false,
  downloadSingleInvoiceFetching: false,
  singleInvoiceDetails: null,
  mappedExpensesColumnsList: {
    primary: [],
    item: [],
    payment: [],
  },
  mappedRevenueColumnsList: {
    primary: [],
    item: [],
    payment: [],
  },
  activeAddInvoiceType: "expenses", // this refers to currently active tab
  success: null,
  error: null,
  statusCode: null,
  message: null,
  invoicesList: [],
  lockedExpensesEntriesDate: null,
  invoicesCount: 0,
  clientCode: null,
  companyName: null,
  allComments: [],
  invoiceHistoryFetching: false,
  invoiceHistoryCount: null,
  invoiceHistoryData: [],
  filters: {
    searchString: "",
    paymentStatus: {
      all: false,
      partiallyPaid: false,
      pending: false,
      paid: false,
      purchaseOrder: false,
      estimation: false,
    },
    drawerFilters: {
      date: {
        dateType: "1",
        startDate: null,
        endDate: null,
      },
      approval: "",
      fileAttachment: "",
      comment: "",
      ocrFilter: false,
      createdThrough: [],
      invoiceCategory: [],
      invoiceDocumentType: [],
      lockUnlockFilter: false,
      allocation: [
        { label: "Allocated", isChecked: false, value: "allocated" },
        { label: "Partially Allocated", isChecked: false, value: "partial" },
        { label: "Unallocated", isChecked: false, value: "unallocated" },
      ],
      branch: null,
    },
    sorting: "default",
    isOverdueReminderEnabled: false,
  },
  bulkUploadHistoryData: [],
  bulkUploadCount: 0,
  bulkUploadData: null,
  eWayBillReviewData: {} as EWayBillReviewDataType,
  eWayBillError: "",
  pinCodeDistanceCountData: {} as PinCodeDistanceCountDataType,
  pinCodeError: "",
  eWayBillUpdateError: "",
  isDuplicateInvoiceEntry: false,
  refetchCustomerSupplierDetails: true,
  refetchInvoicesList: 0,
  refetchOtherInvoicesList: 0,
  singleOtherInvoiceDetails: null,
  uploadedBankStatementList: [],
  uploadedBankStatementCount: 0,
  allPaymentLedgerList: [],
  bankTransactionFilters: {
    startDate: null,
    endDate: null,
    transactionType: "",
    status: "",
  },
  uploadBankStatementMessage: null,
  invoiceDownloadDetails: null,
  uploadedBankStatementTransactionList: [],
  uploadedBankStatementTransactionCount: 0,
  uploadedBankStatementSummary: {},
  allBranchList: [],
  bankStatementTransactionCommentList: [],
  transactionCommentFetching: false,
  transactionCommentSuccess: null,
  postTransactionCommentSuccess: null,
  postCommentFetching: false,
  fileUploadFetching: false,
  uploadedBankStatementFetching: false,
  emailTimelineFetching: false,
  overdueInvoiceEmailTimelineData: null,
  lockUnlockResponseFetching: false,
};
